/* Sprezzatura — cadrage automatique des photos dans les grilles collection / recherche.
   Même principe que la grille de la page d'accueil : la photo est affichée en entier
   (object-fit: contain), puis on repère le produit sur le fond uni et on l'ajuste pour
   qu'il occupe ~74 % du cadre, sans jamais le couper. */
(function () {
  var TOL = 22, FILL = 0.74, MAX_SCALE = 2.4;
  var SELECTOR = '.product-grid .product-media__image';
  var cache = {};

  function productBox(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve) {
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var w = 120, h = Math.max(1, Math.round(w * probe.naturalHeight / probe.naturalWidth));
          var c = document.createElement('canvas'); c.width = w; c.height = h;
          var ctx = c.getContext('2d'); ctx.drawImage(probe, 0, 0, w, h);
          var d = ctx.getImageData(0, 0, w, h).data;
          var r = d[0], g = d[1], b = d[2];
          var x0 = w, y0 = h, x1 = -1, y1 = -1;
          for (var y = 0; y < h; y++) {
            for (var x = 0; x < w; x++) {
              var i = (y * w + x) * 4;
              if (Math.abs(d[i] - r) > TOL || Math.abs(d[i + 1] - g) > TOL || Math.abs(d[i + 2] - b) > TOL) {
                if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
              }
            }
          }
          if (x1 < 0) return resolve(null);
          resolve({ x0: x0 / w, x1: (x1 + 1) / w, y0: y0 / h, y1: (y1 + 1) / h, ratio: probe.naturalWidth / probe.naturalHeight });
        } catch (e) { resolve(null); }
      };
      probe.onerror = function () { resolve(null); };
      probe.src = src.replace(/([?&])width=\d+/, '$1width=200');
    });
    return cache[src];
  }

  function frame(img) {
    var box = img.parentElement;
    var src = img.currentSrc || img.src;
    if (!box || !src) return;
    productBox(src).then(function (b) {
      if (!b || !box.clientHeight) return;
      var frameRatio = box.clientWidth / box.clientHeight;
      var rw = b.ratio > frameRatio ? 1 : b.ratio / frameRatio;
      var rh = b.ratio > frameRatio ? frameRatio / b.ratio : 1;
      var bw = (b.x1 - b.x0) * rw, bh = (b.y1 - b.y0) * rh;
      var cx = (1 - rw) / 2 + (b.x0 + b.x1) / 2 * rw;
      var cy = (1 - rh) / 2 + (b.y0 + b.y1) / 2 * rh;
      var s = Math.min(FILL / bw, FILL / bh, MAX_SCALE);
      if (s < 1) s = 1;
      img.style.setProperty('--cg-s', s.toFixed(3));
      img.style.setProperty('--cg-tx', (-(cx - 0.5) * s * 100).toFixed(2) + '%');
      img.style.setProperty('--cg-ty', (-(cy - 0.5) * s * 100).toFixed(2) + '%');
    });
  }

  function handle(img) {
    if (img.dataset.szFramed) return;
    img.dataset.szFramed = '1';
    if (img.complete && img.naturalWidth) frame(img);
    else img.addEventListener('load', function () { frame(img); }, { once: true });
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(handle);
  }

  function init() {
    scan();
    // Produits chargés au défilement ou après un filtre
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { scan(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
